<template>
  <div class="main-content">
    <div class="reports-title">{{ adminText('workflowsAll.reports_88bc3fe', 'Reports') }}</div>
    <div class="card-container">
      <div class="row-container">
        <div
          class="reports-box"
          @click="
            goTo(routes.ticketSellerAdmin.reportAdmin, { selectedReportType: ReportTypes.DAILY })
          "
        >
          <div class="reports-box-title">{{ adminText('workflowsAll.daily_sales_report_8c52942', 'Daily Sales Report') }}</div>
          <div class="reports-box-subtitle">{{ adminText('workflowsAll.an_overview_of_all_ticket_sales_for_a_specifi_89e2d64', 'An overview of all ticket sales for a specific day') }}</div>
        </div>
        <div
          class="reports-box"
          @click="
            goTo(routes.ticketSellerAdmin.reportAdmin, { selectedReportType: ReportTypes.MONTHLY })
          "
        >
          <div class="reports-box-title">{{ adminText('workflowsAll.monthly_sales_report_9a40f09', 'Monthly Sales Report') }}</div>
          <div class="reports-box-subtitle">
            {{ adminText('workflowsAll.an_overview_of_all_ticket_sales_for_a_specifi_151744a', 'An overview of all ticket sales for a specific month') }}
          </div>
        </div>
      </div>
      <div class="row-container">
        <div
          class="reports-box"
          @click="
            goTo(routes.ticketSellerAdmin.reportAdmin, { selectedReportType: ReportTypes.YEARLY })
          "
        >
          <div class="reports-box-title">{{ adminText('workflowsAll.yearly_sales_report_82259bb', 'Yearly Sales Report') }}</div>
          <div class="reports-box-subtitle">
            {{ adminText('workflowsAll.an_overview_of_all_ticket_sales_for_a_specifi_913e800', 'An overview of all ticket sales for a specific year') }}
          </div>
        </div>
        <div
          class="reports-box"
          @click="
            goTo(routes.ticketSellerAdmin.reportAdmin, { selectedReportType: ReportTypes.CUSTOM })
          "
        >
          <div class="reports-box-title">{{ adminText('workflowsAll.custom_sales_report_510eef6', 'Custom Sales Report') }}</div>
          <div class="reports-box-subtitle">
            {{ adminText('workflowsAll.an_overview_of_all_ticket_sales_for_a_custom__30202ce', 'An overview of all ticket sales for a custom period of time') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { ReportTypes } from '@/types'

export default {
  mixins: [WorkflowDisplay],
  data() {
    return {
      ReportTypes,
    }
  },
}
</script>

<style scoped>
.main-content {
  max-width: 676px;
  margin: 0 auto;
}

.row-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  justify-content: space-between;
}

.reports-title {
  color: #ff4c00;
  font-size: 2.25rem;
  font-weight: 800;
  font-family: 'Raleway', sans-serif;
  line-height: 120%;
  letter-spacing: -0.03em;
  margin-bottom: 2rem;
}

.reports-box {
  height: 100px;
  border-radius: 24px;
  background-color: #f5f5f5;
  padding: 16px 24px;
  min-width: 50%;
  margin-right: 1rem;
  cursor: pointer;
}

.reports-box-title {
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.03em;
  color: #0277bd;
}

.reports-box-subtitle {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 120%;
  color: #333333;
  margin-top: 8px;
}

@media only screen and (max-width: 1112px) {
  .main-content {
    max-width: 550px;
  }
}

@media only screen and (max-width: 980px) {
  .main-content {
    max-width: 480px;
  }
}

@media only screen and (max-width: 900px) {
  .main-content {
    max-width: 350px;
  }

  .reports-box {
    height: 150px;
  }
}

@media only screen and (max-width: 800px) {
  .main-content {
    max-width: 550px;
  }

  .reports-box {
    height: 100px;
  }
}

@media only screen and (max-width: 550px) {
  .row-container {
    flex-direction: column;
    row-gap: 12px;
  }
  .reports-box {
    height: 100px;
  }
  .reports-box-title {
    font-size: 18px;
  }

  .reports-box-subtitle {
    font-size: 13px;
  }
}
</style>
